<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { propTypes } from '@/utils/propTypes'
import { solarIcons, getSolarIcons } from './solarIcons'

const props = defineProps({
  // icon name
  icon: propTypes.string,
  // icon color
  color: propTypes.string,
  // icon size
  size: propTypes.number.def(16),
  hoverColor: propTypes.string
})

onMounted(() => {
  if (props.icon.includes('solar')) {
    getSolarIcons()
  }
})

const iconPath = computed(() => {
  if (!solarIcons.value) return ''
  
  let iconName = ''
  if (props.icon.startsWith('solar:')) {
    iconName = props.icon.replace('solar:', '')
  } else if (props.icon.startsWith('vi-solar:')) {
    iconName = props.icon.replace('vi-solar:', '')
  } else {
    iconName = props.icon
  }
  return solarIcons.value.icons[iconName]?.body || 'asteroid-bold'
})

const svgAttrs = computed(() => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: props.size,
  height: props.size,
  viewBox: '0 0 24 24',
  style: {
    color: props.color || 'currentColor'
  }
}))
</script>

<template>
  <div class="icon-wrapper">
    <svg v-bind="svgAttrs" v-html="iconPath"></svg>
  </div>
</template>

<style lang="less" scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    display: inline-block;
    vertical-align: middle;

    &:hover {
      color: v-bind(hoverColor);
    }
  }
}
</style>
